import { TYPE_COLLECTION } from './input-types';

export const id = 'shipmentNumber';
export const apiKey = 'FulfillmentPlanId';
export const type = TYPE_COLLECTION;

export const shipmentNumber = {
  id,
  apiKey,
  type,
};
